<template>
  <div class="col-md-12">
    <div class="card card-container">
      <div
        v-if="messages"
        class="blink"
        style="
          color: red;
          font-size: 1.1em;
          font-weight: bold;
          padding: 5px 5px 0px 0px;
        "
      >
        {{ messages }}
      </div>

      <h2>New Testrun</h2>

      <div id="newTest">
        <!-- <Form @submit="handleNewTest" :validation-schema="schema" v-slot="{ errors }"> -->
        <Form @submit="handleNewTest">
          <div v-if="!successful">
            <div class="form-group">
              <label><span class="orange">1.</span> Project</label>
              <select
                class="form-select form-select-lg mb-6"
                @change="onProject($event)"
              >
                <option :value="null">Select Project</option>
                <option v-for="project in projects" :value="project.id">
                  {{ project.name }}
                </option>
              </select>
              <span class="text-danger">*</span>

              <!-- <p>Selected id: {{ choosed }}</p> -->
            </div>
            <div class="form-group" v-if="projectSuites">
              <label for="testSuite"
                ><span class="orange">2.</span> Test Suite</label
              >
              <select
                class="form-select form-select-lg mb-6"
                name="testSuite"
                v-model="testSuite"
                id="testSuite"
                required
                @change="onTestSuite($event)"
              >
                <option value="null">Select Suite</option>
                <option v-for="suite in projectSuites" :value="suite.id">
                  {{ suite.name }}
                </option>
              </select>
              <span class="text-danger">*</span>

              <!-- <ErrorMessage name="testSuite" v-model="testSuite" class="error-feedback" /> -->
            </div>
            <template v-if="suiteConfigArr.length > 0">
              <div
                style="
                  border: dashed;
                  border-color: ;
                  background-color: aliceblue;
                  padding: 0.4rem 0.5rem 0 0.5rem;
                "
              >
                <h5>Suite Configuration:<span class="text-danger">*</span></h5>
                <em
                  ><strong style="color: red"
                    >Please make sure you at least click on each field.</strong
                  ></em
                ><br />
                <em v-html="suiteDesc"></em>
                  <br />
                <div
                  v-if="isStudioTrafficGeneratorwithNRR"
                  style="position: right; display: inline-block"
                >
                  <label
                    @click="triggerFileUpload"
                    style="
                      display: inline-block;
                      background-color: #007bff;
                      color: white;
                      padding: 10px 20px;
                      border-radius: 5px;
                      cursor: pointer;
                      font-size: 12px;
                      text-align: center;
                      margin-right: 30px;
                  transition: background-color 0.3s;
                    "
                    onmouseover="this.style.backgroundColor='#0056b3'"
                    onmouseout="this.style.backgroundColor='#007bff'"
                  >
                    Choose File
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    ref="fileUpload"
                    @change="replaceFile"
                    style="
                     display: none;
                    "
                  />
                  <div v-if="uploadedFileName" style="margin-top: 10px;">
            <strong>Uploaded File:</strong> {{ uploadedFileName }}
               </div>
                </div>
                <div style="float: right">
                  <button
                    class="btn btn-primary"
                    @click="
                      $event.preventDefault();
                      showTestCases(suiteTests);
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-clipboard-list"
                      size="lg"
                    />
                    TEST CASES
                  </button>
                </div>
                <table>
                  <tr
                    v-for="item in suiteConfigArr"
                    class="form-group"
                    v-if="suiteConfigArr.length > 0"
                  >
                    <td style="width: 40%">
                      <label :for="item.fieldName"
                        >{{ item.fieldLabel }}:</label
                      >
                    </td>
                    <td style="width: 80%">
                      <select
                        @change="updateConfigObject($event)"
                        v-if="item.fieldValue.toString().startsWith('enum:')"
                        :name="item.fieldName"
                        :v-model="item.fieldName"
                        autofocus
                      >
                        <option
                          v-for="enumItem in returnEnumArr(item.fieldValue)"
                          :value="enumItem"
                        >
                          {{ humanReadable(enumItem) }}
                        </option>
                      </select>
                      <Field
                        @change="updateConfigObject($event)"
                        v-if="
                          item.fieldValue !== 'boolean' &&
                          !item.fieldValue.toString().startsWith('enum:') &&
                          item.fieldName !== 'config_platformName' &&
                          !item.fieldName.toString().endsWith('Password')
                        "
                        :id="item.fieldName"
                        :name="item.fieldName"
                        :value="item.fieldValue"
                        :v-model="item.fieldName"
                        type="text"
                        class="form-control"
                        @keyup="updateConfigObject($event)"
                        @focus="updateConfigObject($event)"
                        autofocus
                      />

                      <Field
                        @change="updateConfigObject($event)"
                        v-if="
                          item.fieldValue !== 'boolean' &&
                          !item.fieldValue.toString().startsWith('enum:') &&
                          item.fieldName !== 'config_platformName' &&
                          item.fieldName.toString().endsWith('Password')
                        "
                        :id="item.fieldName"
                        :name="item.fieldName"
                        :value="item.fieldValue"
                        :v-model="item.fieldName"
                        type="password"
                        class="form-control"
                        @keyup="updateConfigObject($event)"
                        @focus="updateConfigObject($event)"
                        autofocus
                      />

                      <select
                        @change="updateConfigObject($event)"
                        v-if="item.fieldValue === 'boolean'"
                        :name="item.fieldName"
                        :v-model="item.fieldName"
                        autofocus
                      >
                        <option value="">-- Select --</option>
                        <option value="true">True</option>
                        <option value="false">False</option>
                      </select>

                      <!-- <select @change='updateConfigObject($event)' v-if='item.fieldName === "config_platformName"'
                        :name='item.fieldName' :v-model="item.fieldName" autofocus>
                        <option value=""> Select </option>
                        <option value="Sitecore"> Sitecore </option>
                        <option value="Drupal"> Drupal </option>
                      </select> -->
                      <!-- <Field @change='updateConfigObject($event)' v-if='item.fieldValue === "password"' :name='item.fieldName' :v-model="item.fieldName" type="text" :placeholder="Password" class="form-control" @keyup="updateConfigObject($event)" @focus="updateConfigObject($event)" autofocus /> -->
                    </td>
                  </tr>
                </table>
              </div>
            </template>

            <Field
              name="suiteConfig"
              v-model="suiteConfig"
              type="hidden"
              :value="suiteConfig"
            />

            <!-- <p>{{suiteConfig}}</p> -->

            <div class="form-group">
              <label for="environment"
                ><span class="orange">3.</span> Environment</label
              >
              <select
                class="form-select form-select-lg mb-6"
                name="environment"
                v-model="environment"
                id="environment"
                required
              >
                <option value="">Select Environment</option>
                <option value="QA" selected>QA</option>
                <option value="STAGING">STAGING</option>
                <option value="PROD">PROD</option>
                <option value="CUSTOM">CUSTOM</option>
              </select>
              <span class="text-danger">*</span>
            </div>
            <div class="form-group">
              <label for="customBase"
                >Custom Base URL (if environment is CUSTOM, leave empty
                otherwise):</label
              >
              <Field
                name="customBase"
                v-model="customBase"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <table style="width: 100%">
                <tr>
                  <td style="width: 30%">
                    <label for="name"
                      ><span class="orange">4.</span> Run Name:
                      <span class="text-danger">*</span></label
                    >
                  </td>
                  <td>
                    <Field
                      name="name"
                      v-model="name"
                      type="text"
                      class="form-control"
                      style="width: 70%"
                    />
                    <!-- <ErrorMessage name="name" v-model="name" class="error-feedback" /> -->
                  </td>
                </tr>
              </table>
            </div>

            <div class="form-group">
              <label for="browser"
                ><span class="orange">5.</span> Browser</label
              >
              <select
                class="form-select form-select-lg mb-6"
                name="browser"
                v-model="browser"
                id="browser"
              >
                <option value="" selected>Select Browser</option>
                <option value="chromium">Chrome</option>
                <option value="firefox">Firefox</option>
              </select>
              <span class="text-danger">*</span>
            </div>

            <div class="form-group">
              <label class="label__lg" for="runAt">Run Time:</label>
              <span class="text-small"
                >Leave deafult date to execute ASAP.</span
              >
              <Field
                name="runAt"
                v-model="runAt"
                type="text"
                class="form-control"
                :value="datePicked"
              />
              <ErrorMessage
                name="runAt"
                v-model="runAt"
                class="error-feedback"
              />
            </div>

            <div class="form-group">
              <label for="recipients">+Recipients (comma separated)</label>
              <Field
                name="recipients"
                v-model="recipients"
                type="recipients"
                class="form-control"
              />
              <ErrorMessage
                name="recipients"
                v-model="recipients"
                class="error-feedback"
              />
            </div>

            <div class="form-group">
              <label for="repeat">Repeat?</label>
              <select
                @change="onRepeat($event)"
                class="form-select form-select-lg mb-6"
                name="repeat"
                v-model="repeat"
                id="repeat"
              >
                <option value="">Select Interval</option>
                <option value="once">Once</option>
                <option value="daily">Every Day</option>
                <option value="weekly">Weekly</option>
                <option value="biweekly">Biweekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>

            <div class="form-group" v-if="repeatRun">
              <label for="workDaysOnly">Workdays Only?</label>
              <span class="text-small"
                >If this needs to be a continous run for an evironment, contact
                QA leads to adjust the testrun's continuty flag.</span
              >
              <br />
              <select
                class="form-select form-select-lg mb-6"
                name="workDaysOnly"
                v-model="workDaysOnly"
                id="workDaysOnly"
              >
                <option value="" selected>Select Option</option>
                <option value="false">False</option>
                <option value="true">True</option>
              </select>
            </div>

            <div v-if="repeatRun" class="form-group">
              <!-- <code>repeatRun: {{repeatRun}}</code> -->
              <label for="runUntil">Run Until (date):</label>
              <Field
                @change="updateRunUntil($event)"
                :value="datePicked"
                name="runUntilUser"
                type="text"
                class="form-control"
              />
            </div>

            <Field
              name="runUntil"
              v-model="runUntil"
              type="hidden"
              value="{{runUntilTime}}"
            />

            <div class="form-group">
              <button
                type="submit"
                class="btn btn-primary btn-block"
                :disabled="loading"
              >
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Schedule!
              </button>
            </div>
          </div>
        </Form>

        <div
          v-if="message"
          class="alert"
          :class="successful ? 'alert-success' : 'alert-danger'"
        >
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
// import * as yup from "yup";
import TestRunsService from "../services/testruns.service";
import MockService from "../services/mock.service";

import moment from "moment";

// import { ref } from "vue"

// import Datepicker from 'vue3-datepicker'

// const datePicked = ref(new Date())
// import { defineComponent, watch } from 'vue'

export default {
  name: "NewTest",
  components: {
    Form,
    Field,
    ErrorMessage,
    // Datepicker
  },

  data() {
    return {
      testSuite: Form.testSuite,
      environment: "",
      customBase: "",
      browser: "",
      name: "",
      repeat: "",
      suiteConfig: {},
      runUntilTime: null,
      suiteDesc: "",
      suiteTests: [],
      // configJson: {},
      suiteConfig: {},
      suiteConfigArr: [],
      recipients: [],
      runAt: "",
      datePicked: "",
      repeatRun: null,
      workDaysOnly: "",
      runUntil: null,
      successful: false,
      loading: false,
      message: "",
      messages: "",
      projects: [],
      projectSuites: [],
      isStudioTrafficGeneratorwithNRR: false,
      STUDIO_TRAFFIC_GENERATOR_ID_NRR: "6751d36e4e15e918609b087c",
    };
  },
  watch: {},
  methods: {
    handleNewTest() {
      this.message = "";
      this.successful = false;
      this.loading = true;
      let recipientsObj = [];
      if (this.recipients.length > 5) {
        recipientsObj = this.recipients.split(",").map((email) => email.trim());
      }

      // console.log('recipientObj: ', JSON.stringify(recipientsObj));
      const payload = {
        testSuite: this.testSuite,
        environment: this.environment,
        customBase: this.customBase,
        browser: this.browser,
        name: this.name,
        suiteConfig: this.suiteConfig,
        recipients: recipientsObj,
        // Array.from(arrayLike
        runAt: this.datePicked,
        workDaysOnly: `${this.workDaysOnly}`,
        runUntil: this.runUntil,
      };

      if (
        this.workDaysOnly !== null ||
        this.workDaysOnly !== "" ||
        this.workDaysOnly === "true"
      ) {
        payload.workDaysOnly = `${this.workDaysOnly}`;
      }

      if (
        this.repeat !== null ||
        this.repeat !== "" ||
        this.repeat === "once"
      ) {
        payload.repeat = this.repeat;
      }

      if (this.runUntilTime !== null || this.runUntilTime !== "") {
        payload.runUntil = this.runUntil;
      }

      if (!this.suiteConfig.headless) {
        payload.suiteConfig.headless = true;
      }

      if (this.customBase !== null || this.customBase !== "") {
        payload.suiteConfig.customBase = this.customBase;
      }

      if (this.repeat === null || this.repeat === "") {
        this.workDaysOnly = "false";
      }

      // console.log('PAYLOAD: ', JSON.stringify(payload, null, 2));

      TestRunsService.createTestRun({
        ...payload,
      }).then(
        (response) => {
          this.message = `${JSON.stringify(response.data)}`;
          this.successful = true;
          this.loading = false;
          this.showSuccess(this.message);
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.showFailed(this.message);
        }
      );
    },

    onRepeat: function (event) {
      const repeatEvent = event.target;
      console.log("REPAT EVENT: ", JSON.stringify(repeatEvent, null, 2));
      // const keyName = item.getAttribute('name').replace('config_', '');
      if (repeatEvent.value === "once") {
        this.repeatRun = null;
      } else if (repeatEvent.value === "") {
        this.repeatRun = null;
      } else {
        this.repeatRun = event.target.value;
      }
    },

    updateRunUntil: function (event) {
      this.runUntilTime = event.target.value;
      this.runUntil = this.runUntilTime;
    },

    updateConfigObject: function (event) {
      if (event.target.value !== null) {
        const item = event.target;
        const keyName = item.getAttribute("name").replace("config_", "");
        const keyValue = item.value;
        const itemJson = { [keyName]: keyValue };

        Object.assign(this.suiteConfig, itemJson);

        // this.suiteConfig.push(itemJson);
      } else {
        this.repeatRun = null;
      }
    },

    onProject: function (event) {
      const suiteValue = event.target.selectedOptions[0].value;

      if (suiteValue !== "null") {
        TestRunsService.getProjectSuites(suiteValue).then(
          (response) => {
            this.projectSuites = response.data.results;
            // console.log('getProjectSuites: \n', JSON.stringify(this.projects, null, 2));
          },
          (error) => {
            this.content =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      } else {
        this.projectSuites = [];
      }
    },

    onTestSuite: function (event) {
      const testSuiteValue = event.target.selectedOptions[0].value;
      this.isStudioTrafficGeneratorwithNRR = false;
      if (testSuiteValue === "null") {
        this.suiteConfigArr = [];
      } else {
        const selectedSuite = this.projectSuites.find(
          (element) => element.id === testSuiteValue
        );
        this.isStudioTrafficGeneratorwithNRR =
          selectedSuite.id === this.STUDIO_TRAFFIC_GENERATOR_ID_NRR;
        const suiteConfig = selectedSuite.suiteConfig;
        // console.log(`suiteConfig: ${JSON.stringify(suiteConfig, null, 2)}`);
        this.suiteDesc = selectedSuite.description;
        this.suiteTests = [...selectedSuite["testCases"]];
        // this.suiteTests.push(selectedSuite['testCases']);

        let renderConfig = [];

        /** Humanize field names */
        const humanizeStr = (string) => {
          let humanized = string
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, function (str) {
              return str.toUpperCase();
            });
          return humanized;
        };

        for (let keyName in suiteConfig) {
          let renderItem = {};
          let copiedName = keyName.toString();
          renderItem.fieldName = "config_" + keyName;
          renderItem.fieldValue = suiteConfig[keyName];

          // let enumField;

          // if (renderItem.fieldValue.startsWith('enum:')) {

          //   enumField = renderItem.fieldValue.split(':')[0];

          // }

          renderItem.fieldLabel = humanizeStr(copiedName);
          renderConfig.push(renderItem);

          // suiteConfig['config_' + keyName] = suiteConfig[keyName];
          // delete suiteConfig[keyName];
        }
        // console.log(`renderConfig: ${JSON.stringify(renderConfig, null, 2)}`)
        this.suiteConfigArr = renderConfig;
      }
    },
    triggerFileUpload() {
      this.$refs.fileUpload.click();
    },
 async replaceFile(event) {
      const newFile = event.target.files[0];
      if (!newFile) {
        alert("Please select a file to upload.");
        return;
      }

      // Update the uploaded file name
      this.uploadedFileName = newFile.name;

      // Show the confirmation alert after displaying the file name
      const confirmed = confirm(`Are you sure you want to replace the existing file with "${newFile.name}"?`);
      if (!confirmed) {
        return;
      }

      try {
        const formData = new FormData();
        formData.append('file', newFile);
        formData.append('folder', '../../autostax/data/searchterms');
        console.log("FORM DATA:", formData);
        const response = await MockService.uploadFileforsearchtermfolder(formData);
        console.log("RESPONSE:", response);
        if (response.status !== 200) {
          alert("Failed to replace the file.");
        }
        else {
          alert(`File replaced successfully with "${newFile.name}".`);
        }
      } catch (error) {
        console.error("Error replacing file:", error);
        alert("Failed to replace the fileasdasdasdasd.");
      }
    },
    humanReadable(string) {
      let humanized = string
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, function (str) {
          return str.toUpperCase();
        });
      return humanized;
    },
    /**
     * Returns an array of values
     * @param {object} string "enum:value1,value2,value3"
     */
    returnEnumArr(object) {
      const valuesArr = object.toString().split(":")[1].split(",");
        valuesArr.push("-- Select --");
        valuesArr.sort((a, b) => {
          const numA = Number(a);
          const numB = Number(b);
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          } else {
            return a.localeCompare(b);
          }
        });
        return valuesArr;
      // enumItem in item.fieldValue.toString().split(':')[1].split(',')
    },

    getProjectSuites(projectID) {
      TestRunsService.getProjectSuites(projectID).then(
        (response) => {
          this.projectSuites = response.data.results;
          console.log(JSON.stringify(this.projects, null, 2));
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },

    showTestCases(tests) {
      let testList = "";
      for (let testCase in tests) {
        testList += `<li>${tests[testCase]}</li>`;
      }
      // console.log('testList: ', testList);
      this.$swal({
        position: "center",
        // icon: 'info',
        title: "Test Cases",
        imageUrl: "/pass_fail.png",
        imageWidth: 200,
        imageHeight: 100,
        imageAlt: "To pass or not to pass...",
        html: '<div style="text-align:left"><ul>' + testList + "</ul></div>",
        // text: message,
        showConfirmButton: true,
        // timer: 2000
      });
    },

    showSuccess(message) {
      this.$swal({
        position: "center",
        icon: "success",
        title: "Your Test scheduled!",
        text: message,
        showCloseButton: true,
        timer: 5000,
      }).then(() => {
        window.location.href = "/testruns";
      });
    },

    showFailed(message) {
      this.$swal({
        position: "center",
        icon: "error",
        title: "Oops...",
        text: message,
        showConfirmButton: true,
        // timer: 2000
      });
      
    },
    },

  computed: {
    currentUser() {
      const currentUser = this.$store.state.auth.user;
      this.userTZ = currentUser.user.timezone;
      return currentUser;
    },
  },

  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
    this.loading = false;
    this.userTZ = this.$store.state.auth.user.user.timezone;

    this.runAt = moment(new Date().toLocaleString("en-US"))
      .tz(this.userTZ)
      .format("MM/DD/YYYY HH:mm");
    this.datePicked = moment(new Date().toLocaleString("en-US"))
      .tz(this.userTZ)
      .format("MM/DD/YYYY HH:mm");

    console.log("CURRENT USER:", JSON.stringify(this.currentUser, null, 2));

    // const fieldMatch = new RegExp('/config_.*/')

    // this.$refs.input.focus();

    TestRunsService.getProjects().then(
      (response) => {
        this.projects = response.data.results;
        this.projectSuites = [];
        // console.log(JSON.stringify(this.projects, null, 2));
      },
      (error) => {
        this.messages =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};

</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}

.orange {
  color: #ff714e;
}

.card-container.card {
  max-width: 800px !important;
  padding: 0px 40px 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 30px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

textarea {
  background: hsla(0, 0%, 100%, 0.8);
  border: none;
  border-radius: 4px;
  color: #3b4151;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  min-height: 280px;
  outline: none;
  padding: 10px;
  width: 100%;
}

.error-feedback {
  color: red;
}

.blink {
  animation: 1.5s linear infinite condemned_blink_effect;
}

@keyframes condemned_blink_effect {
  0% {
    visibility: hidden;
  }

  50% {
    visibility: hidden;
  }

  100% {
    visibility: visible;
  }
}
</style>
